import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@/lib/theme';

export function ThemeToggle() {
  const { theme, toggle } = useTheme();
  const Icon = theme === 'dark' ? Sun : Moon;
  const label = `Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`;
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={label}
      title={label}
      className="border-fw-border bg-fw-surface text-fw-text-secondary hover:bg-fw-surface-hover hover:border-fw-border-strong hover:text-fw-text active:bg-fw-surface focus-visible:ring-fw-ring inline-flex h-11 w-11 items-center justify-center rounded-full border transition-colors duration-150"
    >
      <Icon size={18} strokeWidth={1.75} aria-hidden />
    </button>
  );
}
